<template lang="pug">
.expansion-container
  .transfer-num {{cardInfo.cardNum}}
  .transfer-sign {{cardInfo.cardSign}}
  .transfer-block(v-if="start")
    .tarnsfer-sign
      img(src="https://m.hellobike.com/resource/helloyun/08345/1jwLGiMUws.png?x-oss-process=image/quality,q_80")
    scrollNumber(:value="getTimes()")
    .sign {{cardInfo.cardSign}}
  .top-word 限时升级
</template>
<script>
import scrollNumber from './scroll-number.vue';
import {
  RIGHTS_TYPE,
} from '../../consts';

export default {
  components: {
    scrollNumber,
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      start: false,
      timer: null,
    };
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.start = true;
    }, 500);
  },
  destroyed() {
    this.timer = null;
  },
  methods: {
    getTimes() {
      if (this.cardInfo.vipExtendProperty) {
        if (this.cardInfo.vipExtendProperty.propType === 4
        || this.cardInfo.vipExtendProperty.propType === 7) {
          return this.cardInfo.vipExtendProperty.propTimes;
        } if (this.cardInfo.vipExtendProperty.propType === RIGHTS_TYPE.discount) {
          return this.cardInfo.vipExtendProperty.propDiscount;
        }
        return this.cardInfo.vipExtendProperty.propAmount;
      }

      return 0;
    },
  },

};
// 0.5秒以后开始滚动
</script>
<style lang="less" scoped>
.expansion-container {
  @keyframes shrinkAndMove {
    from {
      transform: scale(1) translate(0, 0);
    }

    to {
      transform: scale(0.6) translate(-0.16rem, 0.05rem);
    }
  }

  @keyframes shrinkAndMoveSign {
    from {
      transform: scale(1) translate(0, 0);
    }

    to {
      transform: scale(0.9) translate(-0.14rem, 0.01rem);
    }
  }

  display: flex;
  justify-content: center;
  position: relative;

  .transfer-num {
    font-size: 0.26rem;
    font-weight: 700;
    font-family: DINAlternate-Bold, sans-serif;
    color: #f54311;
    animation: shrinkAndMove 0.5s forwards;
    /* 动画持续时间为3秒，完成后保持最后状态 */
    line-height: 0.26rem;
    margin-top: 0.07rem;
  }

  .transfer-sign {
    font-family: PingFang SC, sans-serif;
    font-size: 0.11rem;
    font-weight: 400;
    line-height: 0.11rem;
    text-align: center;
    color: #f54311;
    margin-top: 0.19rem;
    animation: shrinkAndMoveSign 0.5s forwards;
  }

  .transfer-block {
    display: flex;
    margin-left: -0.1rem;

    .tarnsfer-sign {
      margin-top: 0.15rem;
      margin-right: -0.13rem;

      img {
        width: 0.1rem;
        height: 0.126rem;
      }
    }

    .sign {
      margin-left: -0.1rem;
      margin-top: 0.15rem;
      font-size: 0.11rem;
      color: #f54311;
    }
  }

  .top-word {
    position: absolute;
    top: -0.08rem;
    left: 0.03rem;
    width: 0.48rem;
    height: 0.15rem;
    background: linear-gradient(90deg, #ff9938 0%, #ff4333 100%);
    border-radius: 0.5rem 0.5rem 0.5rem 0;
    font-family: PingFang SC, sans-serif;
    font-size: 0.1rem;
    font-weight: 500;
    line-height: 0.15rem;
    text-align: center;
    color: #fff;
  }
}
</style>
